import Skeleton from '@/components/core/Skeleton';
import styled from 'styled-components';
import { Image as CoreImage } from '@starsoft/common/components';

export const Image = styled(CoreImage)`
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};
`;

export const Icon = styled(CoreImage)`
  width: 70%;
  height: 70%;
  object-fit: cover;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
`;

export const Container = styled.div`
  width: 86px;
  min-width: 86px;
  height: 86px;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  @media (max-width: 768px) {
    width: 72px;
    min-width: 72px;
    height: 72px;
  }
`;

export const CardSkeleton = styled(Skeleton)`
  width: 86px;
  height: 86px;
  border-radius: ${({ theme }) => theme.vars.shape.borderRadius};

  @media (max-width: 768px) {
    width: 72px;
    height: 72px;
  }
`;
